/**
 * Platform badge metadata — aligned with ship_mvp frontend `PLATFORM_CONFIG` / `PlatformLogoMark`.
 * PNG paths match `frontend/public/platform-logos/` (synced from ship-shared).
 */

const LOGO_PREFIX = '/platform-logos/';

export const PLATFORM_BADGES = [
  {
    name: 'YouTube',
    logoPath: `${LOGO_PREFIX}youtube-logo.png`,
    brandColor: '#ff0000',
    fallbackIcon: '📺',
  },
  {
    name: 'Instagram',
    logoPath: `${LOGO_PREFIX}instagram-logo.png`,
    brandColor: '#9333ea',
    fallbackIcon: '🎬',
  },
  {
    name: 'TikTok',
    logoPath: '',
    brandColor: '#0f172a',
    fallbackIcon: '🎵',
  },
  {
    name: 'LinkedIn',
    logoPath: '',
    brandColor: '#2563eb',
    fallbackIcon: '💼',
  },
  {
    name: 'Facebook',
    logoPath: '',
    brandColor: '#2563eb',
    fallbackIcon: '📘',
  },
  {
    name: 'X',
    logoPath: '',
    brandColor: '#0f172a',
    fallbackIcon: '𝕏',
    invertLogo: true,
  },
  {
    name: 'Reddit',
    logoPath: '',
    brandColor: '#ea580c',
    fallbackIcon: '🤖',
  },
];
